export enum ColumnAlignment {
  Left,
  Center,
  Right,
}
